module.exports = __webpack_public_path__ + "static/media/icon-color-fill.947e4171.svg";